import React, {useEffect} from 'react';
import * as S from './Popup.styles';

import IconSelector from '@ibibo/icon-selector';

const PopUp = ({cancelEvent, agreeEvent, termsMarkup, policy}) => {
    useEffect(() => {
        window.scrollTo(0,0);
    },[]);

    let buttonVisible = false;
    if(termsMarkup === ''){
        buttonVisible = true;
    }
    return(
        <S.PopupMainWrapper>
            <S.PopupHeadWrap>
                <S.PopupHeadTextWrap>
                    <S.PopupHeadText>Terms & Conditions</S.PopupHeadText>
                </S.PopupHeadTextWrap>
                {!policy && (
                    <S.PopupHeadCloseWrap>
                        <S.PopupCloseBtn onClick={cancelEvent}>
                            <IconSelector iconKey='close' />
                        </S.PopupCloseBtn>
                    </S.PopupHeadCloseWrap>
                )}
            </S.PopupHeadWrap>
            <S.PopupBodyWrapper>
                {policy && (
                    <S.ImpNote>
                        <S.ImpNoteText>NOTE: Our policy has been updated, please read and accept the policy to move forward.</S.ImpNoteText>
                    </S.ImpNote>
                )}
                <S.PopupContentText dangerouslySetInnerHTML={{__html: termsMarkup.data}}></S.PopupContentText>

                {/* <S.PopuoContentList>
                    <li>The airline tickets available through the Website are subject to the terms & conditions of the concerned airline, including but not limited to cancellation and refund policies.</li>
                    <li>ibibo merely acts as a facilitator to enable the User to book a flight ticket. The contract of service for utilization of the flight is always between the User and the concerned airline.</li>
                    <li>Airlines retain the right to reschedule flight times, route, change or cancel flights or itineraries independent of and without prior intimation to ibibo. As a facilitator ibibo has no control or authority over the logistics of the airlines and therefore is not liable for any loss, direct or incidental, that a User may incur due to such change or cancellation of a flight.</li>
                    <li>Different tickets on the same airline may carry different restrictions or include different services and price.</li>
                    <li>The baggage allowance on given fare is as per the terms decided by the airline, and ibibo has no role to play in the same. Some of the fares shown in the booking flow are “hand baggage fares” which do not entitle the User for free check in baggage and therefore the User will be required to pay separately for check in baggage. The prices for adding check-in baggage to a booking may vary from airline to airline. The User is advised to contact the airlines for detailed costs.</li>
                </S.PopuoContentList> */}

                <S.ButtonWrapper>
                    {!policy && (
                        <S.CancelBtn onClick={cancelEvent}>Cancel</S.CancelBtn>
                    )}
                    <S.AgreeBtn onClick={agreeEvent} disabled={buttonVisible}>I Agree</S.AgreeBtn>
                </S.ButtonWrapper> 
            </S.PopupBodyWrapper>
            
        </S.PopupMainWrapper>
    );
}

export default PopUp;
